import cn from 'classnames';
import React, { HTMLAttributes } from 'react';

import { Button, Input } from '@components/Form/Skeleton';

type SkeletonProps = {
  title?: string;
  numinputs?: number;
} & HTMLAttributes<HTMLDivElement>;

function Skeleton(props: SkeletonProps) {
  const { className, title, ...rest } = props;
  return (
    <div
      className={cn(
        'relative flex flex-grow flex-col overflow-hidden rounded-lg border border-gray-500 bg-gray-200 px-4 py-3 before:absolute before:inset-0 before:-translate-x-full before:skew-x-12 before:skew-y-12 before:animate-skeleton before:bg-gradient-to-r before:from-transparent before:via-gray-500/50 before:to-transparent dark:border-dark-200 dark:bg-dark-500 dark:before:via-dark-200/50',
        className,
      )}
      {...rest}
    >
      <h2 className="text-lg font-light text-gray-500 dark:text-dark-200">
        {title || 'Title'}
      </h2>
      <div className="m-2 border-b border-gray-500" />
      <div className="flex flex-col gap-3 p-2 pt-0 font-light">
        {Array.from({ length: props.numinputs || 2 }).map((_, i) => (
          <>
            <label className='text-gray-500 mb-0'>...</label>
            <Input key={i} />
          </>
        ))}
        <Button />
      </div>
    </div>
  );
}

export default Skeleton;
